import { useState, useEffect, useRef } from 'react'
import { DEBUG_MODE } from '../../utilities/config'

export function useReverseDebounce(value: any, delay: any) {
  const [debouncedValue, setDebouncedValue] = useState<any>(value)
  const isFirstCall = useRef<boolean>(true)

  useEffect(() => {
    try {
      if (isFirstCall.current) {
        setDebouncedValue(value)
        isFirstCall.current = false
        return
      }
      let tid: NodeJS.Timeout | null = setTimeout(() => {
        isFirstCall.current = true
        setDebouncedValue(value)
        try {
          if (tid != null) {
            clearTimeout(tid)
            tid = null
          }
        } catch {}
      }, delay)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
    }
  }, [value, delay])

  return debouncedValue
}
